<template>
	<div>
		<div class="e-title">邮件发送详情</div>
		<el-descriptions :column="1">
			<el-descriptions-item label="接收邮箱">{{ data.emailAddress }}</el-descriptions-item>
			<el-descriptions-item label="电源产品名称">{{ data.productName }}</el-descriptions-item>
			<el-descriptions-item label="电池名称">{{ data.batteryName }}</el-descriptions-item>
			<el-descriptions-item label="电池选择数量">{{ data.batteryCount }}</el-descriptions-item>
			<!-- <el-descriptions-item label="蓄电容量">{{ data.productCapacity }}</el-descriptions-item> -->
			<el-descriptions-item label="持续功率">{{ data.continuousPower }}W</el-descriptions-item>
			<el-descriptions-item label="功率提升模式">{{ data.powerBoostMode }}W</el-descriptions-item>
			<el-descriptions-item label="自耗电量">{{ data.selfConsumption }}W</el-descriptions-item>
			<el-descriptions-item label="输出功率(最大)">{{ data.usableCapacityMax }}W</el-descriptions-item>
			<el-descriptions-item label="浪涌功率(最大)">{{ data.surgePowerMax }}W</el-descriptions-item>
			<el-descriptions-item label="持续时间">
				{{ (data.tipType == 1 || data.tipType == 2) ? data.tipWord : "" }}
			</el-descriptions-item>
			<el-descriptions-item label="发送时间">{{ formatDate(data.createTime) }}</el-descriptions-item>
			<el-descriptions-item label="邮件回执">{{ ['未读', '已读'][data.emailReceipt] }}</el-descriptions-item>
		</el-descriptions>
		<div class="e-title">耗电设备信息</div>
		<el-card style="margin-bottom: 20px" v-for="item in data.loadDeviceList" :key="item.id">
			<div style="display: flex;column-gap: 20px;">
				<img style="height: 150px;width: 150px;object-fit: cover;" :src="item.staticImage" alt="">
				<div style="display: flex; flex-direction: column;justify-content: space-between;font-size: 14px;">
					<div>{{ item.publicName }}</div>
					<el-tag style="width: max-content;" :type="item.chargingType == 1 ? '' : 'success'">
						{{ item.chargingType == 1 ? '充电' : '供电' }}
					</el-tag>
					<template v-if="item.chargingType == 1">
						<div>设备容量：{{ item.deviceCapacity }}</div>
						<div>设备充电次数：{{ item.deviceChargeCount }}</div>
					</template>
					<template v-else>
						<div>设备持续功率：{{ item.continuousPower }}</div>
						<div>设备浪涌功率：{{ item.surgePower }}</div>
						<div>设备运行时间：{{ item.operationTime }}</div>
					</template>
				</div>
			</div>
		</el-card>
		<div v-html="data.imgHtml"></div>
	</div>
</template>

<script>
import { detail } from "@/api/email";
import dayjs from "dayjs";
export default {
	data() {
		return {
			data: {},
		}
	},
	mounted() {
		const id = this.$route.query.id;
		detail(id).then(({ code, data, message }) => {
			if (code == 200) {
				this.data = data;
			} else {
				this.$message.error(message);
			}
		});
	},
	methods: {
		formatDate(date) {
			return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
		},
	}
}
</script>

<style></style>